import React from 'react';

import s from './Description.module.scss';

const Description = () => {

    return (
        <div className={s.description}>
            <h2>Саванна</h2>
            <p>Саванна — это активная игра по переводу слов. После запуска игры вы увидите падающее слово. Вам необходимо выбрать одно правильное значение
                 из четырех вариантов, пока слово падает. Неверный ответ или несвоевременный — является ошибкой. Ошибиться можно 5 раз. После пяти ошибок 
                 тренировка прекращается..</p>
        </div>
    )

};

export default Description;